<template>
    <!-- 
    05-12-23: Ver manejo de dialogos nuevo con un callback para despues
     -->
    <div>
        <v-card flat :class="$vuetify.breakpoint.mdAndUp ? 'pb-0 mb-0' : 'pb-5 mb-3'">
            <DialogoExito ref="refDialExito"></DialogoExito>
            <DialogoExtemporaneo ref="refDialogoExt" :titulo="title" :text="text"></DialogoExtemporaneo>
            <DialogoInfoLaboral ref="dialogoInfo" :titulo="this.titulo" @repiteEmpleo="mismoEmpleo" />
            <DialogoOpcionNivel width="960px" ref="dialogo" @nivelSelected="nivelActual" :tipo="this.tipo"
                :titulo="titulo" />
            <ValidationObserver ref="obs" v-slot="{ invalid }">
                <v-form name="formNivel" @submit.prevent="submit">
                    <v-row class="d-flex flex-column pt-2 ">
                        <v-col cols="12" md="12">
                            <ValidationProvider rules="required" v-slot="v">
                                <v-select outlined ref="select" v-model="dataSelected.nuevoNivel" :items="itemNivel"
                                    class="always-active" append-icon="mdi-menu-down" autofocus
                                    :class="{ 'primary--border': !isFocused }"
                                    :item-text="item => (!obj) ? (dataSelected.altaPJ) ? `NIVEL ${item.nivel} (${opcionNivelAfiliado.cantModulosAR} Módulos)` : `NIVEL ${item.nivel} (${item.cantMod} Módulos)` : `NIVEL 2 (Reducción de aportes)`"
                                    :error-messages="v.errors[0]" item-value="nivel" :menu-props="customMenuProps"
                                    @click="goToNiveles" @focus="isFocused = true" @blur="isFocused = false"
                                    :label="`Seleccioná una Opción de Nivel para ${opcionNivelAfiliado.anioOpcionNivel}`" />
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12" v-if="dataSelected.nuevoNivel > 2" class="pt-0">
                            <v-alert v-if="(estadoActivoPlanJoven || estadoActivoRAR)" type="warning" class="rounded-0"
                                dense color="orange darken-2" icon="mdi-alert-outline">
                                <div class="font-weight-regular text-body-1 white--text">
                                    Al seleccionar <b>NIVEL {{ dataSelected.nuevoNivel }}</b>, se dará de baja
                                    automáticamente
                                    el <b>{{ labelEstadoActivo }}</b>.
                                </div>
                            </v-alert>
                        </v-col>
                        <v-col cols="12" md="12"
                            v-if="(dataSelected.nuevoNivel == 2) && tieneReduccionAnterior && opcionNivelAfiliado.nivelActual !== 2"
                            class="pt-0">
                            <v-alert type="info" class="rounded-0" dense color="orange darken-2"
                                icon="mdi-information-outline">
                                <div class="py-2 font-weight-regular text-body-1 white--text">
                                    Tenés vigente un<b>
                                        {{ labelEstadoInactivo }}
                                    </b>
                                    .¿Querés volver a
                                    activarlo?
                                </div>
                                <v-radio-group v-model="opcionReduccion"
                                    :rules="[v => v !== null || 'Debes seleccionar una opción']" class="white--text">
                                    <v-radio
                                        :label="`Si, deseo reactivar el plan de aporte reducido (${opcionNivelAfiliado.cantModulosAR} Módulos)`"
                                        :value="1" color="white">
                                        <template v-slot:label>
                                            <span class="white--text">
                                                Si, deseo reactivar el <b>PLAN DE APORTE REDUCIDO
                                                    ({{ opcionNivelAfiliado.cantModulosAR }} Módulos)
                                                </b>
                                            </span>
                                        </template>
                                    </v-radio>
                                    <v-radio :value="0" color="white">
                                        <template v-slot:label>
                                            <span class="white--text">
                                                No, quiero aportar <b>NIVEL 2 completo (40 Módulos)</b>
                                            </span>
                                        </template>
                                    </v-radio>
                                </v-radio-group>
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row v-if="(dataSelected.nuevoNivel == 1)" class="d-flex flex-column ma-0 pa-0">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-checkbox dense v-model="dataSelected.esJubilado" :error-messages="v.errors[0]"
                                :true-value=1 :false-value=0 :input-value=0 class="py-0 my-0 ">
                                <template v-slot:label>
                                    <div :class="(dataSelected.esJubilado) ? 'primary--text' : ''">
                                        Soy jubilado de ANSES/IPS.
                                    </div>
                                </template>
                            </v-checkbox>
                        </ValidationProvider>
                        <v-row v-if="!mostrarCard" class="mx-0">
                            <v-col cols="12" md="12" class="px-0 pb-3">
                                <v-card-title>
                                    <div class="font-weight-bold text-body-1 primary--text text-uppercase">
                                        Información laboral
                                    </div>
                                </v-card-title>
                            </v-col>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-text-field dense v-model="dataSelected.empleo"
                                        @input="dataSelected.empleo = dataSelected.empleo.toUpperCase()"
                                        :error-messages="v.errors[0]" type="text" label="Empleador">
                                    </v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required|max:100" v-slot="v">
                                    <v-text-field dense v-model="dataSelected.empleoTipo" :error-messages="v.errors[0]"
                                        type="text" label="Tipo de Empleo"
                                        @input="dataSelected.empleoTipo = dataSelected.empleoTipo.toUpperCase()">
                                    </v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required|max:10" v-slot="v">
                                    <v-text-field v-model="dataSelected.empleoDesde" dense
                                        label="Fecha de inicio de actividad:" type="date"
                                        :error-messages="v.errors[0]"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row v-else class="d-flex flex-row">
                            <v-col cols="12" md="12">
                                <AlertaLaboral></AlertaLaboral>
                            </v-col>
                        </v-row>
                        <v-col cols="12" md="12" class="mt-2 px-0">
                            <AlertaNiveles :activo="(dataSelected.esJubilado)"></AlertaNiveles>
                        </v-col>
                    </v-row>
                    <v-row v-if="dataSelected.nuevoNivel == 1" class="d-flex flex-row my-2"
                        :class="($vuetify.breakpoint.mdAndDown) ? 'justify-center' : 'justify-space-around'">
                        <InputButtonArchivo op="reciboSueldoHaberes"
                            :label="(!dataSelected.esJubilado) ? 'RECIBO DE SUELDO' : 'RECIBO DE HABERES'"
                            @fileSelected="handleFileSelected"></InputButtonArchivo>
                        <InputButtonArchivo op="archNivel"
                            :label="(!dataSelected.esJubilado) ? 'CERTIFICADO LABORAL' : 'RESOLUCIÓN DE JUBILACIÓN'"
                            @fileSelected="handleFileSelected"></InputButtonArchivo>
                    </v-row>
                    <v-row
                        v-if="dataSelected.nuevoNivel !== '' && (dataSelected.nuevoNivel != 2 || !tieneReduccionAnterior || (tieneReduccionAnterior && dataSelected.altaPJ !== undefined))"
                        class="ma-0 pa-0">
                        <v-col cols="12" md="12" class="py-5 px-0 pb-12">
                            <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                                <v-checkbox dense v-model="confirmarNivel" :error-messages="v.errors[0]"
                                    @change="handleFileSelected"
                                    :disabled="(dataSelected.nuevoNivel == 2) && tieneReduccionAnterior && opcionNivelAfiliado.nivelActual !== 2 && (opcionReduccion === null || opcionReduccion === undefined)"
                                    class="font-weight-bold">
                                    <template v-slot:label>
                                        <div :class="confirmarNivel ? 'primary--text' : ''">
                                            {{ nivelLabel }}
                                        </div>
                                    </template>
                                </v-checkbox>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-card-actions class="d-flex align-center custom-card-actions-ha " @click="forzarValidacion"
                        :class="$vuetify.breakpoint.mdAndUp ? 'justify-end' : 'form-footer justify-end'">
                        <v-btn class="pa-5 px-8 elevation-0" :disabled="invalid || !invalidFiles" type="submit"
                            :loading="loading" color="primary">
                            <v-icon class="mr-2">mdi-send-outline</v-icon>enviar trámite</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </div>
</template>

<script>

import DialogoExtemporaneo from '@/components/dialogos/DialogoExtemporaneo.vue'
import DialogoExito from '@/components/dialogos/DialogoExito.vue'
import DialogoInfoLaboral from '@/components/dialogos/DialogoInfoLaboral.vue'
import DialogoOpcionNivel from '@/components/dialogos/DialogoOpNivel.vue'
import AlertaNiveles from '@/components/alerts/AlertaNiveles.vue';
import AlertaLaboral from '@/components/cards/Laboral.vue';
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapGetters, mapActions } from 'vuex';

export default {
    components: {
        InputButtonArchivo,
        AlertaNiveles,
        AlertaLaboral,
        ValidationObserver,
        ValidationProvider,
        DialogoOpcionNivel,
        DialogoInfoLaboral,
        DialogoExito,
        DialogoExtemporaneo
    },
    data() {
        return {
            isFocused: false,
            loading: false,
            titulo: '',
            tipo: '',
            width: '',
            icon: '',
            obj: false,
            dataSelected: {
                nroafi: '',
                nuevoNivel: '',
                esJubilado: 0,
                repiteEmpleo: 0,
                nuevoNivelEmail: '',
                empleo: '',
                estadoNivelPedido: '',
                empleoTipo: '',
                empleoDesde: '',
                altaPJ: 0,
                bajaPJ: 0,
            },
            opcionReduccion: null,
            op: 'niveles1',
            rules: 'required|ext:jpg,pdf,jpeg',
            rulesCert: 'ext:jpg,pdf,jpeg',
            customMenuProps: { openOnClick: false },
            files: '',
            files1: '',
            invalidFiles: 'false',
            blockEmpleo: false,
            label: 'Tomo conocimiento de que al optar por realizar mis aportes en el Nivel 1 (aportación reducida), percibiré una jubilación reducida que resultará complementaria a la que recibiré por mi trabajo en relación de dependencia aquí declarado, y por el cual me encuentro aportando en otro régimen previsional (art. 41, 42, 70 y 72 Ley 12.163 y modif. y reglamentaciones vigentes)',
            confirmacion: false,
            confirmarNivel: false,
            mostrarCard: false,
            title: '',
            text: ''
        }
    },
    watch: {
        'opcionReduccion'(newValue) {
            this.confirmarNivel = false
            if (newValue === 1) {
                this.dataSelected.altaPJ = 1;
                this.dataSelected.bajaPJ = 0;
            } else if (newValue === 0) {
                this.dataSelected.altaPJ = 0;
                this.dataSelected.bajaPJ = 1;
            }
        }
    },
    mounted() {
        //        this.$refs.select.focus()
        console.log('mounted FormNivel')
        /*         if (!this.opcionNivelAfiliado.tienePlanJovenFuturo || !this.opcionNivelAfiliado.tieneRarFuturo) {
                    this.dataSelected.nuevoNivel = 2
                } */
        //this.dataSelected.nuevoNivel = this.opcionNivelAfiliado.nivelActual
        if (this.opcionNivelAfiliado.nroafi !== '') {
            this.dataSelected.nroafi = this.nroafi
            this.dataSelected.esJubilado = this.dataSelected.esJubilado
            this.dataSelected.nuevoNivelEmail = this.emailPrinc.email
        } else {
            this.getNivelAfiliado()
        }

    },
    computed: {
        ...mapGetters(['emailPrinc']),
        ...mapGetters('preafiliacion', ['datosContacto', 'aporteReducido', 'datosNivel']),
        ...mapGetters('common', ['itemNivel']),
        ...mapGetters('opcionNivel', ['opcionNivelAfiliado', 'datosNivelAfiliado', 'extemporaneo']),
        ...mapGetters('dataUser', ['archNivel', 'archNivel1', 'resolucionJubilacion', 'reciboSueldoHaberes']),
        ...mapGetters('auth', ['user', 'isAuthenticated', 'nroafi']),

        nivelLabel() {
            if (this.dataSelected.nuevoNivel == 1) {
                return this.label + ' .';
            } else if (this.dataSelected.nuevoNivel == 2 && this.tieneReduccionAnterior && this.dataSelected.altaPJ == 1 && this.opcionNivelAfiliado.nivelActual != 2) {
                return `Confirmo que deseo reactivar mi ${this.labelEstadoInactivo} vigente (${this.opcionNivelAfiliado.cantModulosAR} Módulos).`;
            }
            else if (this.dataSelected.nuevoNivel == 2 && this.opcionNivelAfiliado.nivelActual == 2 && this.tieneReduccionAnterior) {
                // actualizo bajaPJ a 1
                this.dataSelected.bajaPJ = 1;
                this.dataSelected.altaPJ = 0;
                return `Estas seleccionando pagar nivel 2 completo (40 Módulos), Se dará de baja el ${this.labelEstadoInactivo} vigente.`
            }
            else if (this.dejaPlanReducido) {
                return `Confirmo que deseo solicitar el NIVEL ${this.dataSelected.nuevoNivel}, que implica un aumento en mi aporte mensual.`;
            }
            else if (this.dataSelected.nuevoNivel) {
                return `Confirmo que deseo solicitar el NIVEL ${this.dataSelected.nuevoNivel}.`;
            } else {
                return '';
            }
        },
        nivelActualLabel() {
            if (this.opcionNivelAfiliado.nivelActual == 2 && this.opcionNivelAfiliado.tienePlanJoven) {
                return 'PLAN MÓDULO JOVEN'
            } else if (this.opcionNivelAfiliado.nivelActual == 2 && this.opcionNivelAfiliado.tieneRar) {
                return 'RÉGIMEN DE APORTACIÓN REDUCIDA'
            } else if (this.opcionNivelAfiliado.nivelActual == 1) {
                return 'NIVEL 1'
            } else if (this.opcionNivelAfiliado.nivelActual == 3) {
                return 'NIVEL 3'
            } else if (this.opcionNivelAfiliado.nivelActual == 4) {
                return 'NIVEL 4'
            } else if (this.opcionNivelAfiliado.nivelActual == 5) {
                return 'NIVEL 5'
            }

        },

        estadoActivoPlanJoven() {
            return (this.opcionNivelAfiliado.tienePlanJovenFuturo && this.opcionNivelAfiliado.estadoPlanJovenFuturo == "A")
        },
        estadoActivoRAR() {
            return (this.opcionNivelAfiliado.tieneRarFuturo && this.opcionNivelAfiliado.estadoRarFuturo == "A")
        },
        labelEstadoActivo() {
            if (this.estadoActivoPlanJoven) {
                return 'PLAN MÓDULO JOVEN'
            } else if (this.estadoActivoRAR) {
                return 'RÉGIMEN DE APORTACIÓN REDUCIDA'
            }
            return ''
        },
        labelEstadoInactivo() {
            if (this.opcionNivelAfiliado.tienePlanJoven) {
                return 'PLAN MÓDULO JOVEN'
            } else if (this.opcionNivelAfiliado.tieneRar) {
                return 'RÉGIMEN DE APORTACIÓN REDUCIDA'
            }
            return ''
        },
        tienePlanJovenAnterior() {
            return this.opcionNivelAfiliado.tienePlanJovenFuturo
        },
        tieneRarAnterior() {
            return this.opcionNivelAfiliado.tieneRarFuturo
        },
        tieneReduccionAnterior() {
            return this.tienePlanJovenAnterior || this.tieneRarAnterior
        },
        // El afiliado tiene PMJ/RAR y elige un nivel completo (2 sin reactivar, o 3 en adelante)
        // que no es inferior a su nivel actual: pasa a aportar mas, por eso la confirmacion lo explicita.
        dejaPlanReducido() {
            const tienePlanReducido = this.tieneReduccionAnterior || this.estadoActivoPlanJoven || this.estadoActivoRAR
            const nuevoNivel = Number(this.dataSelected.nuevoNivel)
            const nivelActual = Number(this.opcionNivelAfiliado.nivelActual) || 0
            return nuevoNivel >= 2 && nuevoNivel >= nivelActual && tienePlanReducido && this.dataSelected.altaPJ != 1
        },

    },
    methods: {
        ...mapActions(['refreshData']),
        ...mapActions('dataUser', ['addFiles', 'guardarDatosNivel', 'crearFormDataNivel']),
        ...mapActions('opcionNivel', ['nuevaOpcionNivel', 'desestimarOpcionNivel', 'getNivelAfiliado']),
        ...mapActions('notificaciones', ['showSnack']),
        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                // this.onBlur();
            });
        },
        resetConfirmacion() {
            this.confirmarNivel = false;
        },
        nivelItemText(item) {
            if (this.opcionNivelAfiliado.altaPJ === 1 && item.nivel == 2) {
                return `NIVEL REDUCIDO (${this.opcionNivelAfiliado.cantModulosAR})`;
            }
            return `NIVEL ${item.nivel} (${item.cantMod} Modulos)`;
        },
        handleFileSelected() {
            if (this.dataSelected.nuevoNivel !== 1) {
                return false
            }
            else {
                /**
                 validacion de plan activo anterior
                 *  */
                /*             
    
                                if (this.tienePlanJovenAnterior || this.tieneRarAnterior) {
                                    this.text = `Tenés un plan de aporte reducido (${this.labelEstadoInactivo}). ¿Querés volver a activarlo?`;
                                    this.$refs.refDialogoExt.abrirDialog().then((result) => {
                                        if (result) {
                
                                        } else {
                                            this.confirmarNivel = false
                                            return null
                                        }
                                    })
                                } else {
                
                                } */
                console.log("cambio change");
                (this.reciboSueldoHaberes.length !== 0) ? this.invalidFiles = true : this.invalidFiles = false
                this.$emit('valid', this.invalidFiles)
            }
        },

        formatDate(date) {
            if (!date) return null
            if (date.includes('/')) {
                const [year, month, day] = date.split('/')
                return `${day}-${month}-${year}`
            } else {
                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            }
        },

        goToNiveles() {
            this.$refs.select.blur()
            this.titulo = 'Elegí un nivel de aportes para ' + this.opcionNivelAfiliado.anioOpcionNivel
            this.tipo = 'nivel'
            this.width = 900
            this.$refs.dialogo.abrirDialogo().then((result) => {
                if (!result) {
                    this.dataSelected.nuevoNivel = ''
                }
            })
        },
        /*         cagarArchivos(value) {
                    (value) ? this.files = value : this.files = '';
                    if (this.isAuthenticated) {
                        this.addFiles({ file: this.files, op: 'nivel' })
                    }
                },
                cagarArchivos1(value) {
                    (value) ? this.files1 = value : this.files1 = ''
                    if (this.isAuthenticated) {
                        this.addFiles({ file: this.files1, op: 'nivel1' })
                    }
                }, */

        nivelActual(value) {
            this.confirmarNivel = false
            if (this.isObject(value)) {
                this.dataSelected.nivel = value.nivel
                //this.$emit('setNivel', value.nivel)
                this.dataSelected.reducido = (value.reduce == true) ? 1 : 0
                this.dataSelected.tipoAporte = value.tipoAporte
                this.obj = true
            } else {
                if ((value == 1) && (
                    this.opcionNivelAfiliado.empleo ||
                    this.opcionNivelAfiliado.empleoTipo ||
                    this.opcionNivelAfiliado.empleoDesde
                )) {
                    this.dataSelected.esJubilado = 0
                    this.$refs.dialogoInfo.abrirDialogo()
                }
                this.obj = false
                this.dataSelected.empleo = ''
                this.dataSelected.empleoTipo = ''
                this.dataSelected.empleoDesde = ''
                // Limpiar flags de reducción si el nivel no es 2
                if (value != 2) {
                    this.dataSelected.altaPJ = 0;
                    this.dataSelected.bajaPJ = 0;
                    this.opcionReduccion = null;
                }
                //this.dataSelected. = 0
                //this.dataSelected.tipoAporte = ''
                this.dataSelected.nuevoNivel = value
            }
            this.$emit('scrollBottom')
        },
        submit() {
            this.dataSelected.nuevoNivelEmail = this.emailPrinc.email
            //this.loading = true
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.dataSelected.nroafi = this.nroafi
                    if (this.mostrarCard) {
                        this.dataSelected.empleo = this.opcionNivelAfiliado.empleo
                        this.dataSelected.empleoTipo = this.opcionNivelAfiliado.empleoTipo
                        /* this.dataSelected.empleoTipo = '' */
                        this.dataSelected.empleoDesde = this.opcionNivelAfiliado.empleoDesde
                    }
                    if (this.extemporaneo) {
                        this.text = `El plazo para solicitar el cambio de nivel ha finalizado. La aprobación de su trámite quedará a reconsideración. ¿Querés continuar?`;
                        this.$refs.refDialogoExt.abrirDialog().then((result) => {
                            if (result) {
                                this.crearFormDataNivel(this.dataSelected).then(() => {
                                    /*                                     setTimeout(() => {
                                                                            location.reload()
                                                                        }, 1000); */
                                })
                            } else {
                                this.showSnack({
                                    message: "Trámite no enviado.",
                                    type: "500"
                                })
                                this.confirmarNivel = false
                                return null
                            }
                        })
                    }
                    else {
                        this.crearFormDataNivel(this.dataSelected).then(() => {
                            /*    setTimeout(() => {
                                   location.reload()
                               }, 1000); */
                            /*                             this.$refs.refDialExito.abrirDialog().then((result) => {
                                                            if (result) {
                            
                                                            }
                                                        }) */
                        })

                    }
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            });
        },
        isObject(value) {
            return (
                typeof value === 'object' &&
                value !== null &&
                !Array.isArray(value)
            )
        },
        itemChanged() {
            if ((this.dataSelected.nivel == 1) && (this.opcionNivelAfiliado.empleo !== "")) {
                this.$refs.dialogoInfo.abrirDialogo()
            }
        },

        mismoEmpleo(value) {
            this.mostrarCard = value
            this.dataSelected.empleo = this.opcionNivelAfiliado.empleo
            this.dataSelected.empleoTipo = this.opcionNivelAfiliado.empleoTipo
            this.dataSelected.empleoDesde = this.opcionNivelAfiliado.empleoDesde
            if (value) {
                this.dataSelected.repiteEmpleo = 1
            } else {
                this.dataSelected.repiteEmpleo = 0
            }
        },
        selectedJubilado() {
            (this.dataSelected.esJubilado) ? this.dataSelected.esJubilado = 1 : this.dataSelected.esJubilado = 0
            console.log(this.dataSelected.esJubilado)
        },
        filesCorrect() {
            this.archObligatorio = true
        },
        desestimarNivel() {
            let desestimar = {
                nroafi: this.opcionNivelAfiliado.nroafi,
                nivelPedidoId: this.opcionNivelAfiliado.nivelPedidoId,
                nivelPedidoNro: this.opcionNivelAfiliado.nivelPedidoNro,
                nivelPedidoEmail: this.opcionNivelAfiliado.emailNivelPedido,
            }
            this.desestimarOpcionNivel(desestimar).then(() => {
                setTimeout(() => {
                    location.reload()
                }, 1000);
            })
        },


    },


}
</script>

<style scope>
.custom-card-actions-ha {
    position: fixed;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    left: 0;
    /* Altura suficiente para el contenido y centrado vertical */
}

/* Aplicamos el estilo para ajustar el tamaño del texto */
.v-list-item__subtitle {
    white-space: normal;
}

.always-active .v-label {
    color: #00A0DF !important;
    font-weight: bold;
    /* Color específico para la etiqueta */
}

.always-active .v-input__control {
    border-color: #00A0DF !important;

    /* Color específico para el borde */
}

.always-active .v-select__selections {
    color: #00A0DF !important;
    /* Color específico para el texto */
}

.always-active .v-select__control {
    border-color: #00A0DF !important;
    /* Color específico para el borde del select */
}

.always-active .v-input__control--outlined .v-input__slot::before {
    border-color: #00A0DF !important;
    /* Color específico para el borde inferior cuando está outlined */
}

.always-active .v-input__control--outlined .v-input__slot::after {
    border-color: #00A0DF !important;
    /* Color específico para el borde superior cuando está outlined */
}

.custom-select .v-input--is-outlined .v-input__control {
    border-color: blue !important;
    /* Cambia el color del borde inactivo a azul */
}

.primary-border .v-input__control {
    border-color: #1976D2 !important;
    /* Vuetify's primary color */
}
</style>